@if (isLoaded) {
  <div class="container-fluid" [@fadeInAnimation]>
    <div class="row">
      <div class="col-lg-2 col-xl-3"></div>
      <div class="col-lg-8 col-xl-6">
        <div class="card mb-3">
          <div class="card-header">
            <fa-icon [icon]="['fas', 'info']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>{{ 'label.ovrig-info-fran-instans' | translate:{ instans: instanceName } }}
          </div>
          <div class="card-body">
            <p class="h5 fw-bold">{{ 'label.' + (arende.arendeTyp.typ === 'kk' ? 'konkurs' : 'foretagsrekonstruktion') | translate }} {{ arende.galdenar.orgnr }} {{ arende.galdenar.namn }}</p>
            @if (!getOvrigInfo.length) {
              <p class="text-muted">{{ 'label.ingen-ovrig-info' | translate }}</p>
            }
            @if (getOvrigInfo.length) {
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">{{ 'label.beskrivning' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (i of getOvrigInfo | orderBy: 'sortering'; track i) {
                      <tr>
                        <td>
                          @if (i.fil && !i.arUrl) {
                            <file-link [file]="i.fil" [caption]="i.fil.beskrivning"></file-link>
                          }
                          @if (i.arUrl) {
                            <button class="btn btn-link btn-nowrap" (click)="openUrl(i.url)" title="{{ i.urlBeskrivning }} ({{ i.url }})" style="outline: 0; outline-offset: 0"><fa-icon [icon]="['fas', 'link']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>{{ i.urlBeskrivning }}</button>
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
